/** Style tag injected into the same-origin Markdoc iframe. */
export const DOCS_FRAME_LINK_CONTRAST_STYLE_ID = "api-portal-docs-link-contrast";

/**
 * Markdoc uses `--accent` (#00B588) on in-page links. That fails WCAG AA on
 * white article backgrounds. Patch the framed document so the SPA a11y scan
 * (and keyboard users) get the darker portal teal.
 *
 * Product docs CSS still lives in glofox-docs; this only covers the iframe.
 */
export function applyDocsFrameLinkContrast(doc: Document): void {
  if (doc.getElementById(DOCS_FRAME_LINK_CONTRAST_STYLE_ID)) return;

  const style = doc.createElement("style");
  style.id = DOCS_FRAME_LINK_CONTRAST_STYLE_ID;
  style.textContent = `
    .breadcrumb a,
    .content a {
      color: #007a5c;
    }
    html[data-theme="dark"] .breadcrumb a,
    html[data-theme="dark"] .content a {
      color: #7eefcf;
    }
  `;
  doc.head.appendChild(style);
}
